

$(document).ready(function () {
  if ($(".testimonials-slider").length) {
    initCardSlider($(".testimonials-slider"), $(".testimonial"));
    equalizeSliderCardsHeight($(".testimonials-slider"));

    $(window).resize(function () {
      equalizeSliderCardsHeight($(".testimonials-slider"));
    });
  }
});

function initCardSlider($slider, $selector) {
  var cardOffset = 5;
  var visibleCardCount = 0;
  $slider.hubSlider({
    selector: $selector,
    button: {
      next: $('.hub-slider-arrow_next'),
      prev: $('.hub-slider-arrow_prev')
    },
    startOffset: cardOffset - 20,
    auto: false,
    opacityStep: 0.07
  });

  $selector.each(function() {
    if ($(this).css("z-index") > 0) {
      visibleCardCount++;
    }
  });
  $slider.css("margin-bottom", visibleCardCount * (cardOffset + 1));
}

function equalizeSliderCardsHeight($slider) {
  var maxCardHeight = 0;
  var $sliderCards = $($slider).find("li");
  $sliderCards.height("auto");
  $sliderCards.each(function () {
    maxCardHeight = ($(this).height() > maxCardHeight) ? $(this).height() : maxCardHeight;
  });
  $sliderCards.height(maxCardHeight);
  $slider.height($sliderCards.eq(0).outerHeight());
}